<template>
  <div>

    <v-btn class="mr-2" x-small outlined @click.stop="dialog = true">
      LOGS
    </v-btn>

    <v-dialog v-model="dialog" width="80%" :scrollable="false">

      <v-card class="" :loading="initializing">
        <v-card-title>
          Application Logs
          <v-spacer>
          </v-spacer>
          <!-- button for logs page -->
          <v-btn class="mr-2 primary--text" text :to="{
      name: 'applicationLogs',
      params: {
        project: application.projectId,
        namespace: application.namespaceId,
        application: application.id,
        device: device.id,
      },
    }" router>
            <v-icon class="mr-1">open_in_new</v-icon>
          </v-btn>

        </v-card-title>
        <v-card-actions v-if="runnables.length > 1">
          <v-select :items="this.runnables" @input="selectRunnable" v-model="selectedRunnable" width="200px"
            item-text="name" item-value="id" label="Container name"></v-select>
          <v-spacer></v-spacer>
        </v-card-actions>
        <v-card-text>
          <div ref="terminal" class="synpse-xterm"></div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<style>
.synpse-xterm {
  padding-top: 10px solid #2b2b2b;
  padding-left: 8px solid #2b2b2b;

  border: 2px solid #ccc; /* Adjust the color and thickness of the border here */  
  border-radius: 5px; /* Optional: adds rounded corners */
}
</style>

<script>
import { Terminal } from "xterm"
import * as fit from "xterm/lib/addons/fit/fit"
import * as webLinks from "xterm/lib/addons/webLinks/webLinks"
import * as search from "xterm/lib/addons/search/search"
import "xterm/dist/xterm.css"

// Define the Solarized Dark color scheme
const solarizedDarkTheme = {
  foreground: '#d2d2d2',
  background: '#2b2b2b',
  cursor: '#adadad',
  black: '#000000',
  red: '#d81e00',
  green: '#5ea702',
  yellow: '#cfae00',
  blue: '#427ab3',
  magenta: '#89658e',
  cyan: '#00a7aa',
  white: '#dbded8',
  brightBlack: '#686a66',
  brightRed: '#f54235',

};

let bindTerminal = (term, websocket) => {
  term.socket = websocket
  let handleWebSocketMessage = function (event) {
    if (event.data instanceof Blob) {
      let reader = new FileReader()
      reader.onload = () => {
        term.write(reader.result.replace('\n', '\n\r'))
      };
      reader.readAsText(event.data);
      // term.scrollToBottom()
    }
  };

  websocket.onmessage = handleWebSocketMessage;

  let heartBeatTimer = setInterval(function () {
    websocket.send(JSON.stringify({ type: "heartbeat", data: "" }))
  }, 20 * 1000);

  websocket.onclose = () => {
    websocket.removeEventListener("message", handleWebSocketMessage)
    delete term.socket
    clearInterval(heartBeatTimer)
  };
};

export function debounce(fn, delay) {
  var timeoutID = null
  return function () {
    clearTimeout(timeoutID)
    var args = arguments
    var that = this
    timeoutID = setTimeout(function () {
      fn.apply(that, args)
    }, delay)
  }
}


export default {
  components: {
    // LogViewer,
  },

  props: {
    device: Object,
    application: Object,
    container: Object,
  },

  data() {
    return {
      initializing: true,
      dialog: false,
      log: '',
      ws: null,
      term: null,
      selectedRunnable: this.container ? this.container.name : '',
      runnables: [],
    }
  },

  computed: {
    projectId() {
      return this.$route.params.project
    },
    loading() {
      return this.$store.state.application.loading
    },
    wsBase() {
      return `${window.location.protocol === "https:" ? "wss://" : "ws://"}${window.location.host}`;
    },
    wsUrl() {
      let token = this.$store.getters.jwt            
      return `${this.wsBase}/api/projects/${this.projectId}/namespaces/${this.application.namespaceId}/applications/${this.application.id}/logs/${this.selectedRunnable}?device=${this.device.id}&follow=true&_t=${token}&tail=1000`
    }
  },

  watch: {
    dialog(val) {
      if (val) {
        this.open()
      } else {
        this.doClose()
      }
    }
  },

  beforeDestroy() {
    // Terminate connection
    this.doClose()
  },

  methods: {
    open() {
      this.dialog = true
      this.fetchApplication()
    },
    selectRunnable(name) {
      this.selectedRunnable = name
      this.clear()
      this.doOpened()
    },
    fetchApplication() {
      let q = {
        projectId: this.projectId,
        namespaceId: this.application.namespaceId,
        applicationId: this.application.id
      }
      this.$store.dispatch('GetApplication', q).then(() => {
        if (this.application.spec.containers != undefined && this.application.spec.containers.length > 0) {
          this.runnables = this.application.spec.containers
        }
        if (this.application.spec.execs != undefined && this.application.spec.execs.length > 0) {
          for (let i = 0; i < this.application.spec.execs.length; i++) {
            this.runnables.push(this.application.spec.execs[i])
          }
        }

        // default to first container for first choice
        if (!this.container) {
          if (this.application.spec.containers != undefined && this.application.spec.containers.length > 0) {
            this.selectedRunnable = this.application.spec.containers[0].name
          } else if (this.application.spec.execs != undefined && this.application.spec.execs.length > 0) {
            this.selectedRunnable = this.application.spec.execs[0].name
          }
        }        

        setTimeout(() => {
          this.initializing = false
          this.doOpened()
        }, 1000)
      })
    },
    doOpened() {
      Terminal.applyAddon(fit)
      Terminal.applyAddon(webLinks)
      Terminal.applyAddon(search)

      this.term = new Terminal({
        rows: 20,
        scrollback: 2000,
        fontSize: 14,
        cursorBlink: false,
        lineWrapping: true,
        cursorStyle: 'bar',
        bellStyle: "sound",
        fontFamily: '"Menlo for Powerline", Menlo, Consolas, "Liberation Mono", Courier, monospace',
        theme: solarizedDarkTheme
      })
      this.term.open(this.$refs.terminal)
      // this.term.fit() // first resizing
      this.onWindowResize()

      this.term.webLinksInit(this.doLink)
      // term.on("resize", this.onTerminalResize);

      window.addEventListener("resize", this.onWindowResize)

      this.ws = new WebSocket(this.wsUrl)
      this.ws.binaryType = 'blob'

      this.ws.onopen = () => {

      };

      this.ws.onclose = () => {
        // console.log('ws.onclose')
      };
      bindTerminal(this.term, this.ws)

      // After 200ms, resize the terminal to fit the window again
      setTimeout(() => {
        // this.onWindowResize()
        this.term.fit()
      }, 1000)

    },
    doClose() {
      window.removeEventListener("resize", this.onWindowResize)
      if (this.ws) {
        this.ws.close()
      }
      if (this.term) {
        this.term.dispose()
      }
    },
    clear() {
      if (this.term) {
        this.term.dispose()
      }
    },
    onWindowResize() {
      this.term.fit()
    },
  }
}

</script>
